import { Navigate, Outlet } from 'react-router';
import { useAuthClient } from '@/lib/authClient';
import { useDeviceConnection } from '@/hooks/use-device-connection';

export function RequireAnon() {
  const { session } = useAuthClient();
  const { data, isPending } = session;
  const { isChecking, isConnected } = useDeviceConnection();

  if (isPending) return <Outlet />;
  if (isChecking) return <Outlet />;

  const expiresAt = data?.expiresAt ? new Date(data.expiresAt) : null;
  const isSessionActive = Boolean(expiresAt && expiresAt > new Date());

  // If user is logged in but no mobile device connected, redirect to register device
  if (isSessionActive && !isConnected) {
    return <Navigate to="/register-device" replace />;
  }

  // If user is logged in and mobile device connected, redirect to main app
  return isSessionActive ? <Navigate to="/" replace /> : <Outlet />;
}
